// extracted by css-extract-rspack-plugin
export default {"header":"DetailViewPage-module__header___W7UTD","footer":"DetailViewPage-module__footer___f3orJ","scrollable":"DetailViewPage-module__scrollable___YdPvr"};